import DatePickerDropdown from 'components/DatePicker/DatePickerDropdown'
import { FilterText } from 'components/UIComponents/ReportSearchFilter/Style/style.js'
import {
  EndMargin,
  ErrorMessage,
  StartMargin,
  Wrappers,
} from 'modules/Report/Styles/Styles.js'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
const DateRangeFilter = ({
  setCreatedAtEnd,
  setCreatedAtStart,
  id,
  clearDate,
  setClearDate,
  setDateError,
}) => {
  const [error, setError] = useState('')
  const [clear, setClear] = useState(false)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  useEffect(() => {
    if (error) {
      setDateError(true)
    } else {
      setDateError(false)
    }
  }, [error])
  const handleStartDateChange = date => {
    setStartDate(date)
    if (date) {
      setCreatedAtStart(moment(date)?.format('DD-MM-YYYY'))
    }
  }
  const handleEndDateChange = date => {
    setEndDate(date)
    if (date) {
      setCreatedAtEnd(moment(date)?.format('DD-MM-YYYY'))
    }
  }

  useEffect(() => {
    setError('')

    if (endDate && moment(startDate).isAfter(endDate)) {
      setError('From Date Cannot Be Greater Than To Date')
    }

    if (startDate && moment(endDate).isBefore(startDate)) {
      setError('To Date Cannot Be Less Than From Date')
    }
  }, [endDate, startDate])

  const onClick = () => {
    setClear(true)
    setCreatedAtEnd('')
    setCreatedAtStart('')
    setError('')
    setStartDate(null)
    setEndDate(null)
  }
  useEffect(() => {
    if (clearDate) {
      onClick()
      setClearDate(false)
    }
  }, [clearDate])
  return (
    <Wrappers>
      <StartMargin>
        <FilterText>{id == 7 ? 'Date' : 'From'}</FilterText>
      </StartMargin>
      <StartMargin>
        <DatePickerDropdown
          label="Start"
          onChange={handleStartDateChange}
          clear={clear}
          setClear={setClear}
          setError={setError}
          error={error}
        />
      </StartMargin>
      {id !== 7 && (
        <>
          <StartMargin>
            <FilterText>To </FilterText>
          </StartMargin>
          <EndMargin>
            <DatePickerDropdown
              label="End"
              startDate={startDate}
              disabledYear={startDate === null}
              onChange={handleEndDateChange}
              clear={clear}
              setClear={setClear}
              setError={setError}
              error={error}
            />
          </EndMargin>
        </>
      )}
      <ErrorMessage>{error ? 'Note: ' + error : ''}</ErrorMessage>
    </Wrappers>
  )
}

export default DateRangeFilter
